module.exports = __webpack_public_path__ + "img/background_loging.7c95892c.jpg";